<!-- Loading bar -->
<fuse-loading-bar></fuse-loading-bar>

<!-- Navigation -->
<fuse-vertical-navigation
    class="dark bg-gray-900 print:hidden"
    [mode]="isScreenSmall ? 'over' : 'side'"
    [name]="'mainNavigation'"
    [navigation]="authService.selectedMarket === 'uzum' ? navigation.default : navigation[authService.selectedMarket]"
    [opened]="!isScreenSmall"
>
    <!-- Navigation header hook -->
    <ng-container fuseVerticalNavigationContentHeader>
        <!-- Logo -->
        <div class="flex h-20 items-center p-6 pb-0 pt-4 relative">
            @if (isWmsEnabled) {
                <button
                    class="-mx-2 flex w-full items-center rounded-lg px-2 py-1 text-left hover:bg-hover"
                    [matMenuTriggerFor]="appMenu"
                >
                    <ng-container *ngTemplateOutlet="logo"></ng-container>
                    <mat-icon class="ml-auto icon-size-5 text-current" [svgIcon]="'heroicons_outline:chevron-up-down'" aria-hidden="true"></mat-icon>
                </button>
                <mat-menu class="min-w-56" #appMenu="matMenu">
                    <button mat-menu-item aria-current="true">
                        <mat-icon [svgIcon]="'heroicons_outline:home'"></mat-icon>
                        <span class="flex items-center">
                            <span>MarketPlus</span>
                            <mat-icon class="ml-3 icon-size-5 text-primary" [svgIcon]="'heroicons_outline:check'" aria-hidden="true"></mat-icon>
                        </span>
                    </button>
                    <a mat-menu-item href="/wms/">
                        <mat-icon [svgIcon]="'heroicons_outline:cube'"></mat-icon>
                        <span transloco="navigation.wms"></span>
                    </a>
                </mat-menu>
            } @else {
                <ng-container *ngTemplateOutlet="logo"></ng-container>
            }
        </div>
        <ng-template #logo>
            <!-- Logo container with indicator -->
            <div class="relative w-11 h-11 shrink-0">
                <!-- Old Logo with fade-out animation -->
                <img
                    class="w-12 transition-all duration-1000 ease-in-out absolute"
                    [class.opacity-0]="!showOldLogo"
                    [class.scale-95]="logoTransitionStarted"
                    src="images/logo/logo-on-dark.png"
                    alt="Old Logo"
                />

                <!-- New Logo with fade-in animation -->
                <img
                    class="w-12 transition-all duration-1000 ease-in-out absolute "
                    [class.opacity-0]="!showNewLogo"
                    [class.opacity-100]="showNewLogo"
                    [class.scale-105]="showNewLogo"
                    src="images/logo/new-logo-on-dark.svg"
                    alt="New Logo"
                />
            </div>

            <span class="font-bold text-3xl ml-2">PLUS</span>
        </ng-template>
    </ng-container>
</fuse-vertical-navigation>

<!-- Wrapper -->
<div class="flex w-full min-w-0 flex-auto flex-col">
    <!-- Header -->
    <div
        class="bg-card relative z-49 flex h-16 w-full flex-0 items-center px-4 shadow dark:border-b dark:bg-transparent dark:shadow-none md:px-6 print:hidden"
    >
        <!-- Navigation toggle button -->
        <button mat-icon-button (click)="toggleNavigation('mainNavigation')">
            <mat-icon [svgIcon]="'heroicons_outline:bars-3'"></mat-icon>
        </button>
        <!-- Components -->
        <div class="ml-auto flex items-center space-x-1 pl-2 sm:space-x-2">
            <mat-form-field
                class="fuse-mat-dense fuse-mat-rounded w-32 sm:w-40"
                [subscriptSizing]="'dynamic'"
            >
                <mat-select
                    [value]="authService.selectedMarket"
                    (selectionChange)="onMarketChanged($event.value)"
                    [placeholder]="'Market'"
                >
                    <mat-option [value]="'uzum'">Uzum Market</mat-option>
                    <mat-option [value]="'ya'">Yandex Market</mat-option>
                </mat-select>
            </mat-form-field>
            <credits></credits>
            <languages></languages>
            <fuse-fullscreen class="hidden md:block"></fuse-fullscreen>
            <button mat-icon-button (click)="onChanged({checked: scheme !== 'dark'} )">
                <mat-icon [svgIcon]="scheme === 'dark' ? 'heroicons_solid:sun' : 'heroicons_solid:moon'"></mat-icon>
            </button>
            <!--            <search [appearance]="'bar'"></search>-->
            <!--            <shortcuts></shortcuts>-->
            <!--            <messages></messages>-->
            <!--<button
                class="lg:hidden"
                mat-icon-button
                (click)="quickChat.toggle()"
            >
                <mat-icon
                    [svgIcon]="'heroicons_outline:chat-bubble-left-right'"
                ></mat-icon>
            </button>-->
            <user [showAvatar]="false"></user>
        </div>
    </div>

    @if (showPlanReminder) {
        <div class="flex flex-wrap items-center justify-center gap-x-2 gap-y-1 border-b px-4 py-2 text-md font-medium print:hidden"
             [ngClass]="planDaysLeft > 5
                 ? 'border-amber-300 bg-amber-100 text-amber-900 dark:border-amber-800 dark:bg-amber-900/40 dark:text-amber-100'
                 : 'border-red-300 bg-red-100 text-red-900 dark:border-red-800 dark:bg-red-900/40 dark:text-red-100'">
            <span class="relative flex shrink-0">
                <span class="reminder-ping absolute inset-0 rounded-full opacity-0"
                      [ngClass]="planDaysLeft > 5 ? 'bg-amber-500' : 'bg-red-500'"></span>
                <span class="reminder-icon relative flex h-7 w-7 items-center justify-center rounded-full shadow"
                      [ngClass]="planDaysLeft > 5 ? 'bg-amber-600' : 'bg-red-600'">
                    <mat-icon class="icon-size-5 text-white" [svgIcon]="'heroicons_solid:clock'"></mat-icon>
                </span>
            </span>
            @if (planDaysLeft > 0) {
                <span transloco="admin.settings.general.finance.reminder"
                      [translocoParams]="{ days: planDaysLeft, date: (planExpireDate | date: 'dd.MM.yyyy') }"></span>
            } @else if (planDaysLeft === 0) {
                <span transloco="admin.settings.general.finance.reminder_today"
                      [translocoParams]="{ date: (planExpireDate | date: 'dd.MM.yyyy') }"></span>
            } @else {
                <span transloco="admin.settings.general.finance.reminder_expired"
                      [translocoParams]="{ date: (planExpireDate | date: 'dd.MM.yyyy') }"></span>
            }
            @if (isEmployee) {
                <span transloco="admin.settings.general.finance.reminder_employee"></span>
            } @else if (canRenewPlan) {
                <a class="font-semibold underline underline-offset-2 hover:no-underline"
                   [routerLink]="'/settings/general/finance'">
                    <span transloco="admin.settings.general.finance.reminder_action"></span>
                </a>
            }
        </div>
    }

    <!-- Uzum API key reminder banner -->
    @if (showApiKeyReminder) {
        <div class="flex flex-wrap items-center justify-center gap-x-2 gap-y-1 border-b border-amber-300 bg-amber-100 px-4 py-2 text-md font-medium text-amber-900 dark:border-amber-800 dark:bg-amber-900/40 dark:text-amber-100 print:hidden">
            <span class="relative flex shrink-0">
                <span class="reminder-ping absolute inset-0 rounded-full bg-amber-500 opacity-0"></span>
                <span class="reminder-icon relative flex h-7 w-7 items-center justify-center rounded-full bg-amber-600 shadow">
                    <mat-icon class="icon-size-5 text-white" [svgIcon]="'heroicons_solid:exclamation-triangle'"></mat-icon>
                </span>
            </span>
            @if (isEmployee) {
                <span transloco="admin.settings.general.api_keys.reminder_employee"></span>
            } @else {
                <span transloco="admin.settings.general.api_keys.reminder"></span>
                <a class="font-semibold underline underline-offset-2 hover:no-underline"
                   [routerLink]="'/settings/general/api-keys'">
                    <span transloco="admin.settings.general.api_keys.reminder_action"></span>
                </a>
            }
        </div>
    }

    <!-- Force password change banner -->
    <!-- @if (forcePasswordChange) {
        <div class="flex items-center justify-center gap-2 bg-amber-500 dark:bg-amber-600 px-4 py-2 text-sm font-medium text-white print:hidden">
            <span transloco="auth.change_password.force_warning"></span>
            <button mat-button class="text-on-primary" (click)="openChangePassword()">
                <span transloco="auth.change_password.title"></span>
            </button>
        </div>
    } -->

    <!-- Content -->
    <div class="flex flex-auto flex-col">
        <!-- *ngIf="true" hack is required here for router-outlet to work correctly.
             Otherwise, layout changes won't be registered and the view won't be updated! -->
        @if (true) {
            <router-outlet></router-outlet>
        }
    </div>

    <!--&lt;!&ndash; Footer &ndash;&gt;
    <div
        class="bg-card relative z-49 flex h-14 w-full flex-0 items-center justify-start border-t px-4 dark:bg-transparent md:px-6 print:hidden"
    >
        <span class="text-secondary font-medium"
            >Plus &copy; {{ currentYear }}</span
        >
    </div>-->
</div>

<!-- Quick chat -->
<!--<quick-chat #quickChat="quickChat"></quick-chat>-->
